import { useState, useRef, useEffect } from 'react';
import { Text, Button } from '@msc-b2c/shared-components';
import { VoyagersClubNoMembershipContainerProps } from '@msc-b2c/interfaces/types';
import styles from './voyagersclubnomembershipcontainer.module.scss';

export function VoyagersClubNoMembershipContainer({
  headerTitle,
  description,
  readMore,
  readLess,
  children,
}: Readonly<VoyagersClubNoMembershipContainerProps>) {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const descRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const descriptionEl = descRef.current;
    if (!descriptionEl) {
      return;
    }

    const lineHeight = Number.parseFloat(getComputedStyle(descriptionEl).lineHeight);
    setIsOverflowing(descriptionEl.scrollHeight > lineHeight * 3);
    setIsExpanded(false);
  }, [description]);

  return (
    <div className={styles['cmp-voyagers-club-no-membership-container']}>
      <div className={styles['cmp-voyagers-club-no-membership-container__header']}>
        <Text
          text={headerTitle}
          tagHtml={'div'}
          styleOption="cmp-text__large"
        />

        <div className={`${styles['cmp-voyagers-club-no-membership-container__description']}`}>
          <div
            ref={descRef}
            className={`${styles['cmp-voyagers-club-no-membership-container__description__text']} ${
              !isExpanded ? styles['is-collapsed'] : ''
            }`}
          >
            <Text
              text={description}
              styleOption="body-default"
            />
          </div>

          {description && isOverflowing && (
            <div
              className={styles['cmp-voyagers-club-no-membership-container__description__toggle']}
            >
              <Button
                text={isExpanded ? readLess : readMore}
                onClick={() => setIsExpanded(!isExpanded)}
                styleOption="cmp-button__link"
              />
            </div>
          )}
        </div>
      </div>
      {children && <div>{children}</div>}
    </div>
  );
}

export default VoyagersClubNoMembershipContainer;
